import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ml-64 min-h-screen bg-gray-50" }
const _hoisted_2 = { class: "p-8" }
const _hoisted_3 = { class: "flex justify-between items-center mb-8" }
const _hoisted_4 = { class: "bg-white rounded-lg shadow-sm border border-gray-200" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center items-center h-48"
}
const _hoisted_6 = {
  key: 1,
  class: "p-12 text-center text-gray-400"
}
const _hoisted_7 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_8 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_9 = { class: "bg-gray-50" }
const _hoisted_10 = {
  key: 0,
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}
const _hoisted_11 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_12 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_13 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_14 = { class: "text-xs text-gray-400" }
const _hoisted_15 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" }
const _hoisted_16 = { class: "px-6 py-4 text-sm text-gray-600 max-w-xs" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_20 = {
  key: 0,
  class: "px-6 py-4 whitespace-nowrap"
}
const _hoisted_21 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 1,
  class: "text-xs text-gray-400 italic"
}
const _hoisted_25 = {
  key: 3,
  class: "px-6 py-4 border-t border-gray-200"
}
const _hoisted_26 = { class: "flex items-center justify-between" }
const _hoisted_27 = { class: "text-sm text-gray-500" }
const _hoisted_28 = { class: "font-medium text-gray-700" }
const _hoisted_29 = { class: "font-medium text-gray-700" }
const _hoisted_30 = { class: "flex space-x-2" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "flex justify-center items-center h-32"
}
const _hoisted_34 = { class: "space-y-1" }
const _hoisted_35 = { class: "relative" }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "space-y-1" }
const _hoisted_38 = { class: "relative" }
const _hoisted_39 = { class: "space-y-1" }
const _hoisted_40 = { class: "relative" }
const _hoisted_41 = {
  key: 0,
  class: "flex justify-center items-center h-24"
}
const _hoisted_42 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_43 = { class: "flex items-start space-x-3" }
const _hoisted_44 = { class: "text-sm" }
const _hoisted_45 = { class: "font-medium" }
const _hoisted_46 = { class: "text-sm text-gray-600" }
const _hoisted_47 = { class: "flex justify-end space-x-2 pt-1" }

import { onMounted, ref, computed } from 'vue';
import { useBillingStore } from '@/store/billing';
import { useOrganizationStore } from '@/store/organizations';
import { useNotificationStore } from '@/store/notifications';
import { useAuthStore } from '@/store/auth';
import type { TopUpRequest } from '@/config/types/responses';
import Modal from '@/components/modal.vue';
import SideBar from '../components/sidebar.vue';
import Header from '../components/header.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'topup-requests',
  setup(__props) {

const billingStore = useBillingStore();
const organizationStore = useOrganizationStore();
const notificationStore = useNotificationStore();
const authStore = useAuthStore();

const currentPage = ref(1);
const showCreateModal = ref(false);
const createLoading = ref(false);
const showApprovalModal = ref(false);
const approvalLoading = ref(false);
const approvalAction = ref<'APPROVED' | 'REJECTED'>('APPROVED');
const pendingRequest = ref<TopUpRequest | null>(null);

const topUpForm = ref({
  organizationId: '',
  amount: 0,
  narration: '',
});

const canApprove = computed(() => {
  const purpose = localStorage.getItem('purpose');
  if (purpose !== 'local') return false;
  const permissions = localStorage.getItem('permissions');
  if (!permissions) return false;
  return permissions.split(',').map((p) => p.trim().toLowerCase()).includes('approve_topup_requests');
});

onMounted(() => {
  billingStore.fetchTopUpRequests(currentPage.value);
  organizationStore.fetchOrganizations(1);
});

function changePage(page: number) {
  currentPage.value = page;
  billingStore.fetchTopUpRequests(page);
}

function formatDate(input: string) {
  if (!input) return '—';
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(date);
}

function statusBadgeClass(status: string) {
  switch (status) {
    case 'APPROVED': return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-green-100 text-green-700';
    case 'REJECTED': return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-red-100 text-red-700';
    case 'PENDING': return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-amber-100 text-amber-700';
    default: return 'px-2 py-0.5 text-xs font-semibold rounded-full bg-gray-100 text-gray-600';
  }
}

function closeCreateModal() {
  showCreateModal.value = false;
  topUpForm.value = { organizationId: '', amount: 0, narration: '' };
  billingStore.clearMessages();
}

async function handleCreateTopUp() {
  createLoading.value = true;
  const success = await billingStore.createTopUpRequest(
    topUpForm.value.organizationId,
    topUpForm.value.amount,
    topUpForm.value.narration,
  );
  createLoading.value = false;

  if (success) {
    notificationStore.showSuccess('Request Created', 'Top-up request submitted successfully.');
    closeCreateModal();
    billingStore.fetchTopUpRequests(currentPage.value);
  } else {
    notificationStore.showError('Request Failed', billingStore.error || 'Failed to create top-up request.');
  }
}

function openApprovalModal(req: TopUpRequest, action: 'APPROVED' | 'REJECTED') {
  pendingRequest.value = req;
  approvalAction.value = action;
  showApprovalModal.value = true;
}

function closeApprovalModal() {
  showApprovalModal.value = false;
  pendingRequest.value = null;
}

async function confirmApproval() {
  if (!pendingRequest.value) return;
  approvalLoading.value = true;
  const success = await billingStore.updateTopUpRequest(pendingRequest.value.id, approvalAction.value);
  approvalLoading.value = false;

  if (success) {
    const label = approvalAction.value === 'APPROVED' ? 'Approved' : 'Rejected';
    notificationStore.showSuccess(`Request ${label}`, `The top-up request has been ${approvalAction.value}.`);
    closeApprovalModal();
    billingStore.fetchTopUpRequests(currentPage.value);
  } else {
    notificationStore.showError('Action Failed', billingStore.error || 'Failed to update request.');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl font-bold text-green-900" }, "Top-Up Requests"),
            _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "Manage organisation account top-up requests")
          ], -1)),
          (_unref(authStore).hasPermissions('create_topup_requests', 'local'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateModal.value = true)),
                class: "bg-green-800 hover:bg-green-700 text-white px-5 py-2.5 rounded-md flex items-center space-x-2 font-medium bg-gradient-to-r from-green-700 to-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200 transform hover:scale-[1.02]"
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "fa-solid fa-plus mr-1" }, null, -1),
                _createTextVNode(" Create Top-up Request ", -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_unref(billingStore).loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
              ])))
            : (_unref(billingStore).topUpRequests.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "fa-solid fa-inbox text-4xl mb-3" }, null, -1),
                  _createElementVNode("p", { class: "text-sm" }, "No top-up requests found", -1)
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _createElementVNode("thead", _hoisted_9, [
                      _createElementVNode("tr", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Organization ", -1)),
                        _cache[11] || (_cache[11] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Amount", -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Narration", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Status", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Created", -1)),
                        (canApprove.value)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_10, "Actions"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(billingStore).topUpRequests, (req) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: req.id,
                          class: "hover:bg-gray-50 transition-colors"
                        }, [
                          _createElementVNode("td", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(req.name), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(req.contactEmail), 1)
                          ]),
                          _createElementVNode("td", _hoisted_15, " UGX " + _toDisplayString(req.amount), 1),
                          _createElementVNode("td", _hoisted_16, [
                            _createElementVNode("span", {
                              title: req.narration,
                              class: "block truncate max-w-xs"
                            }, _toDisplayString(req.narration || '—'), 9, _hoisted_17)
                          ]),
                          _createElementVNode("td", _hoisted_18, [
                            _createElementVNode("span", {
                              class: _normalizeClass(statusBadgeClass(req.status))
                            }, _toDisplayString(req.status), 3)
                          ]),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(formatDate(req.createdAt)), 1),
                          (canApprove.value)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                                (req.status.toLowerCase() === 'pending')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (openApprovalModal(req, 'APPROVED')),
                                        class: "inline-flex items-center px-3 py-1.5 text-xs font-medium text-green-700 bg-green-50 border border-green-200 rounded-md hover:bg-green-100 transition-colors"
                                      }, _cache[15] || (_cache[15] = [
                                        _createElementVNode("i", { class: "fa-solid fa-check mr-1.5" }, null, -1),
                                        _createTextVNode("Approve ", -1)
                                      ]), 8, _hoisted_22),
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (openApprovalModal(req, 'REJECTED')),
                                        class: "inline-flex items-center px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 border border-red-200 rounded-md hover:bg-red-100 transition-colors"
                                      }, _cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "fa-solid fa-xmark mr-1.5" }, null, -1),
                                        _createTextVNode("Reject ", -1)
                                      ]), 8, _hoisted_23)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_24, "No action needed"))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])),
          (_unref(billingStore).pagination.totalPages > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[17] || (_cache[17] = _createTextVNode(" Page ", -1)),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(currentPage.value), 1),
                    _cache[18] || (_cache[18] = _createTextVNode(" of ", -1)),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(billingStore).pagination.totalPages), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("button", {
                      disabled: currentPage.value <= 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage(currentPage.value - 1))),
                      class: "px-3 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                    }, _cache[19] || (_cache[19] = [
                      _createElementVNode("i", { class: "fa-solid fa-chevron-left mr-1" }, null, -1),
                      _createTextVNode("Previous ", -1)
                    ]), 8, _hoisted_31),
                    _createElementVNode("button", {
                      disabled: currentPage.value >= _unref(billingStore).pagination.totalPages,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage(currentPage.value + 1))),
                      class: "px-3 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                    }, _cache[20] || (_cache[20] = [
                      _createTextVNode(" Next", -1),
                      _createElementVNode("i", { class: "fa-solid fa-chevron-right ml-1" }, null, -1)
                    ]), 8, _hoisted_32)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(Modal, {
        show: showCreateModal.value,
        title: "Create Top-up Request",
        size: "max-w-lg",
        onClose: closeCreateModal
      }, {
        default: _withCtx(() => [
          (createLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[21] || (_cache[21] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("form", {
                key: 1,
                class: "space-y-5",
                onSubmit: _withModifiers(handleCreateTopUp, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Organization", -1)),
                  _createElementVNode("div", _hoisted_35, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-building text-gray-400 text-sm" })
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((topUpForm.value.organizationId) = $event)),
                      required: "",
                      class: "block w-full pl-9 pr-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white"
                    }, [
                      _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "Select organisation", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organizationStore).organizationResults, (org) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: org.id,
                          value: org.id
                        }, _toDisplayString(org.name), 9, _hoisted_36))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, topUpForm.value.organizationId]
                    ])
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Select the organisation to top up", -1))
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Amount (UGX)", -1)),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-coins text-gray-400 text-sm" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((topUpForm.value.amount) = $event)),
                      type: "number",
                      min: "1",
                      required: "",
                      class: "block w-full pl-9 pr-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                      placeholder: "e.g. 50000"
                    }, null, 512), [
                      [_vModelText, topUpForm.value.amount]
                    ])
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Amount to credit to the organisation account", -1))
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Narration", -1)),
                  _createElementVNode("div", _hoisted_40, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "absolute top-2.5 left-3 pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-comment-lines text-gray-400 text-sm" })
                    ], -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((topUpForm.value.narration) = $event)),
                      rows: "3",
                      required: "",
                      class: "block w-full pl-9 pr-3 py-2.5 border border-gray-300 rounded-md text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none",
                      placeholder: "Reason for this top-up request"
                    }, null, 512), [
                      [_vModelText, topUpForm.value.narration]
                    ])
                  ]),
                  _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Brief description for this request", -1))
                ]),
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "bg-amber-50 border border-amber-200 rounded-md px-4 py-3 flex items-start space-x-2 text-xs text-amber-800" }, [
                  _createElementVNode("i", { class: "fa-solid fa-triangle-exclamation mt-0.5 flex-shrink-0" }),
                  _createElementVNode("span", null, "This request will require approval before funds are credited to the organisation.")
                ], -1)),
                _createElementVNode("div", { class: "flex justify-end space-x-2 pt-1" }, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: closeCreateModal,
                    class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                  }, " Cancel "),
                  _cache[32] || (_cache[32] = _createElementVNode("button", {
                    type: "submit",
                    class: "px-5 py-2 text-sm font-medium text-white bg-green-800 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                  }, " Submit Request ", -1))
                ])
              ], 32))
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(Modal, {
        show: showApprovalModal.value,
        title: approvalAction.value === 'APPROVED' ? 'Approve Request' : 'Reject Request',
        size: "max-w-md",
        onClose: closeApprovalModal
      }, {
        default: _withCtx(() => [
          (approvalLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, _cache[34] || (_cache[34] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("div", {
                  class: _normalizeClass(approvalAction.value === 'APPROVED'
          ? 'bg-green-50 border border-green-200 rounded-md p-4'
          : 'bg-red-50 border border-red-200 rounded-md p-4')
                }, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("i", {
                      class: _normalizeClass(approvalAction.value === 'APPROVED'
              ? 'fa-solid fa-circle-check text-green-600 mt-0.5'
              : 'fa-solid fa-circle-xmark text-red-600 mt-0.5')
                    }, null, 2),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("p", {
                        class: _normalizeClass(approvalAction.value === 'APPROVED' ? 'font-medium text-green-800' : 'font-medium text-red-800')
                      }, _toDisplayString(approvalAction.value === 'APPROVED' ? 'Approve this request?' : 'Reject this request?'), 3),
                      (pendingRequest.value)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: _normalizeClass(approvalAction.value === 'APPROVED' ? 'text-green-700 mt-1' : 'text-red-700 mt-1')
                          }, [
                            _createElementVNode("span", _hoisted_45, _toDisplayString(pendingRequest.value.name), 1),
                            _createTextVNode(" — UGX " + _toDisplayString(pendingRequest.value.amount), 1)
                          ], 2))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2),
                _createElementVNode("p", _hoisted_46, _toDisplayString(approvalAction.value === 'APPROVED'
            ? 'Approving will credit the specified amount to the organisation account immediately.'
            : 'Rejecting will close this request. The organisation account will not be credited.'), 1),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: closeApprovalModal,
                    class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                  }, " Cancel "),
                  _createElementVNode("button", {
                    onClick: confirmApproval,
                    class: _normalizeClass(approvalAction.value === 'APPROVED'
              ? 'px-5 py-2 text-sm font-medium text-white bg-green-700 rounded-md hover:bg-green-600 focus:ring-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors'
              : 'px-5 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-500 focus:ring-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors')
                  }, _toDisplayString(approvalAction.value === 'APPROVED' ? 'Yes, Approve' : 'Yes, Reject'), 3)
                ])
              ]))
        ]),
        _: 1
      }, 8, ["show", "title"])
    ])
  ], 64))
}
}

})